import DateTime from './DateTime';
import Organization from './Organization';
import AccountSelector from './AccountSelector';
import ActivityAssigmentList from './ActivityAssigmentList';
import ActivityStatusSum from './ActivityStatusSum';
import ActivityStatusSumTable from './ActivityStatusSumTable/ActivityStatusSumTable';
import AuditHistoryChart from './AuditHistoryChart/AuditHistoryChart';
import TitleBar from './TitleBar/TitleBar';
import ImageWA from './ImageWA';

export default {
    AccountSelector,
    ActivityAssigmentList,
    ActivityStatusSum,
    ActivityStatusSumTable,
    AuditHistoryChart,
    Column: () => require('./Column.vue').default,
    Container: () => require('./Container.vue').default,
    DateTime,
    ImageWA,
    Organization,
    Row: () => require('./Row.vue').default,
    TitleBar,
}

export function fixComponents(vue: Vue) {
    // see https://v2.vuejs.org/v2/guide/components-edge-cases#Circular-References-Between-Components
    vue.$options.components!.Column = require('./Column.vue').default;
    vue.$options.components!.Container = require('./Container.vue').default;
    vue.$options.components!.Row = require('./Row.vue').default;
}

export function getComponentName(elementType: string) {
    switch (elementType.toLowerCase()) {
        case 'image': //image is a reserve name
            return 'ImageWA';
        default:
            return elementType;
    }
}